import {
    LEADERSHIP_REPORT_DIMENSIONS_MESSAGES,
    LeadershipReportDimensionsValue
} from '../../constants';

export function getDimensionMessages(dimension: LeadershipReportDimensionsValue) {
    return LEADERSHIP_REPORT_DIMENSIONS_MESSAGES[dimension];
}
